module.exports = __webpack_public_path__ + "img/images/new-landing/owner.png?8a3e9192";